module.exports = __webpack_public_path__ + "img/picto-modifier-disabled.32f87ad4.svg";